// extracted by mini-css-extract-plugin
module.exports = {"container":"HorizontalDivider_container__q_boX","line":"HorizontalDivider_line__4gQiY"};